module.exports = "/content/d484f9b031340fd97312f3fe241b07e7.png";